import { render, staticRenderFns } from "./RatingsList.vue?vue&type=template&id=328adeb7&"
import script from "./RatingsList.vue?vue&type=script&lang=js&"
export * from "./RatingsList.vue?vue&type=script&lang=js&"
import style0 from "./RatingsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports